import { InstreamVideoBuilder } from './InstreamVideoBuilder/InstreamVideoBuilder';

const instreamVideoBuilder = (
  reactDirective,
  $modal,
  $rootScope,
  CreativeService,
  SaveCreativeService
) => {
  return reactDirective(
    InstreamVideoBuilder,
    undefined,
    {
      restrict: 'E'
    },
    {
      $modal,
      $rootScope,
      CreativeService,
      SaveCreativeService
    }
  );
};

instreamVideoBuilder.$inject = [
  'reactDirective',
  '$modal',
  '$rootScope',
  'CreativeService',
  'SaveCreativeService'
];

export default instreamVideoBuilder;
